import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import update from 'immutability-helper';

// store for all kinds of data
class DataStore extends ReduceStore {

    getInitialState() {
        return {isFetching: false};
    }

    isFetching() {
        return this.getState().isFetching;
    }
    get(key) {
        return this.getState()[key];
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.GET_DATA_REQUEST:
                return update(this.getState(), {isFetching: {$set: true}});

            case ActionTypes.GET_DATA_SUCCESS:
                return update(this.getState(), {
                    isFetching: {$set: false},
                    [action.payload.key]: {$set: action.data }
                });

            case ActionTypes.GET_DATA_FAILURE:
                return update(this.getState(), {isFetching: {$set: false}});

            default:
                return state;
        }
    }
}

export default new DataStore(CentricDispatcher);
